import flatpickr from "flatpickr";
import {Czech} from "flatpickr/dist/l10n/cs";
import naja from "naja";

export default function(root) {
	Array.from(root.querySelectorAll('input[data-flatpickr]')).forEach((el) => {
		setup(el).then((disabledDates) => {
			flatpickr(el, {
				locale: Czech,
				enableTime: false,
				dateFormat: 'j. n. Y',
				minDate: el.dataset.minDate ? el.dataset.minDate : null,
				disable: disabledDates,
				onReady: function(selectedDates, dateStr, instance) {
					const event = new CustomEvent('flatpickrReady', {detail: instance})
					el.dispatchEvent(event)
				}
			})
		})
	})

	Array.from(root.querySelectorAll('input[data-flatpickr-time]')).forEach((el) => {
		setup(el).then((disabledDates) => {
			flatpickr(el, {
				locale: Czech,
				enableTime: true,
				noCalendar: true,
				dateFormat: 'H:i',
				defaultHour: el.dataset.hour ? el.dataset.hour : 9,
				minDate: el.dataset.minDate ? el.dataset.minDate : null,
				disable: disabledDates,
				onReady: function() {
					const event = new Event('flatpickrReady')
					el.dispatchEvent(event)
				}
			})
		})
	})

	Array.from(root.querySelectorAll('input[data-flatpickr-datetime]')).forEach((el) => {
		setup(el).then((disabledDates) => {
			flatpickr(el, {
				locale: Czech,
				enableTime: true,
				dateFormat: 'j. n. Y H:i',
				defaultHour: el.dataset.hour ? el.dataset.hour : 9,
				minDate: el.dataset.minDate ? el.dataset.minDate : null,
				disable: disabledDates,
				onReady: function() {
					const event = new Event('flatpickrReady')
					el.dispatchEvent(event)
				}
			})
		})
	})
}


async function setup(el) {
	let disabledDates = []
	const payload = await fetchDisabledDates(el.dataset.fetchDisabledDates)

	if (typeof payload.disabledDates === 'object') {
		disabledDates = payload.disabledDates
	}

	return new Promise((resolve) => {
		resolve(disabledDates)
	})
}


let fetchDisabledDatesResults = {}
function fetchDisabledDates(url) {
	if (url) {
		if (typeof fetchDisabledDatesResults[url] === 'undefined') {
			fetchDisabledDatesResults[url] = naja.makeRequest('GET', url, null, {history: false})
		}
		return fetchDisabledDatesResults[url]

	} else {
		return new Promise((resolve) => {
			resolve({})
		})
	}
}
